import { useEffect } from 'react';
import { notification } from 'antd';

interface SyncNotificationProps {
  isSyncRequired: boolean;
}

function SyncNotification({ isSyncRequired }: SyncNotificationProps) {
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    if (isSyncRequired) {
      // api.open({
      api.info({
        message: 'Synchronization required',
        description:
          'This business partner requires synchronization before it can be edited. '
          + 'If you want to make changes, please click "Sync Business" to load the latest data.',
        duration: 0,
        placement: 'bottomRight',
      });
    }
  }, [isSyncRequired]);

  return contextHolder;
}

export default SyncNotification;
